import { FilterDataSource } from 'src/services';

export const dataSourceTranslations: Record<FilterDataSource, string> = {
  [FilterDataSource.Catalog]: 'Catalog Field',
  [FilterDataSource.DeepTags]: 'AI Tags',
};
